export default __webpack_public_path__ + "static/solutions-bg-bc4fa697a81da1ef39764364a259be05.jpeg";